(function () {
  function cartUrl(path) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}${path.replace(/^\//, '')}`;
  }

  function init() {
    const root = document.querySelector('[data-anchor-root]');
    if (!root || root.dataset.anchorReady === 'true') return;
    root.dataset.anchorReady = 'true';
    root.querySelectorAll('video').forEach((video) => {
      const play = video.play();
      if (play && play.catch) play.catch(() => {});
    });

    const frames = Array.from(root.querySelectorAll('[data-anchor-frame]'));
    frames.forEach((frame) => {
      if (frame.decode) frame.decode().catch(() => {});
    });
    const thumbs = Array.from(root.querySelectorAll('[data-anchor-thumb]'));
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        frames.forEach((frame, frameIndex) => {
          frame.classList.toggle('is-active', frameIndex === index);
        });
        thumbs.forEach((node) => {
          const on = node === thumb;
          node.classList.toggle('is-active', on);
          node.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    });

    const track = root.querySelector('[data-anchor-track]');
    const films = Array.from(root.querySelectorAll('[data-anchor-film]'));
    if (track && films.length) {
      let shown = 0;
      const setFilm = () => {
        const width = track.clientWidth || 1;
        const index = Math.max(0, Math.min(films.length - 1, Math.round(track.scrollLeft / width)));
        if (index === shown) return;
        shown = index;
        films.forEach((film, i) => {
          const on = i === index;
          film.classList.toggle('is-active', on);
          film.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        const active = films[index];
        const strip = active && active.parentElement;
        if (strip) {
          const left = active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2;
          strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      };
      track.addEventListener('scroll', setFilm, { passive: true });
      films.forEach((film, index) => {
        film.addEventListener('click', () => {
          track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        });
      });
    }

    function bindStrip(track, prev, next) {
      if (!track || !prev || !next) return;
      const step = () => {
        const card = track.querySelector('.ms-an-moment');
        if (!card) return track.clientWidth;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 16;
        return card.getBoundingClientRect().width + gap;
      };
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }

    bindStrip(
      root.querySelector('[data-moments-track]'),
      root.querySelector('[data-moments-prev]'),
      root.querySelector('[data-moments-next]')
    );
    bindStrip(
      root.querySelector('[data-reviews-track]'),
      root.querySelector('[data-reviews-prev]'),
      root.querySelector('[data-reviews-next]')
    );

    const offers = Array.from(root.querySelectorAll('[data-anchor-offer]'));
    const button = root.querySelector('[data-anchor-atc]');
    const ship = root.querySelector('[data-anchor-ship]');
    const qtyNow = root.querySelector('[data-anchor-qty-now]');
    const qtyWas = root.querySelector('[data-anchor-qty-was]');

    function selectOffer(offer) {
      offers.forEach((node) => {
        const on = node === offer;
        node.classList.toggle('is-active', on);
        node.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      root.dataset.qty = offer.dataset.qty || '1';
      if (button) button.textContent = offer.dataset.cta || 'Checkout';
      const stickyButton = root.querySelector('[data-anchor-sticky-atc]');
      if (stickyButton && stickyButton.dataset.busy !== 'true') {
        stickyButton.textContent = 'Add to cart';
      }
      if (ship) ship.textContent = offer.dataset.shipping || '';
      if (qtyNow) qtyNow.textContent = offer.dataset.price || '';
      if (qtyWas) qtyWas.textContent = offer.dataset.compare || '';
    }

    const initial = offers.find((offer) => offer.classList.contains('is-active')) || offers[0];
    if (initial) selectOffer(initial);
    offers.forEach((offer) => {
      offer.addEventListener('click', () => selectOffer(offer));
    });

    const sticky = root.querySelector('[data-anchor-sticky]');
    const stickyButton = root.querySelector('[data-anchor-sticky-atc]');
    const buyButtons = [button, stickyButton].filter(Boolean);

    if (sticky && button && 'IntersectionObserver' in window) {
      const watch = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
        sticky.inert = !past;
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        root.classList.toggle('has-sticky', past);
      });
      watch.observe(button);
    }

    async function checkout(trigger) {
      const variantId = root.dataset.variantId;
      const qty = Math.max(1, Number(root.dataset.qty || 1));
      if (!variantId || trigger.disabled) return;
      const labels = buyButtons.map((node) => node.textContent);
      buyButtons.forEach((node) => {
        node.disabled = true;
        node.dataset.busy = 'true';
      });
      trigger.textContent = 'Adding…';
      try {
        await fetch(cartUrl('cart/clear.js'), { method: 'POST', headers: { Accept: 'application/json' } });
        const response = await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty }),
        });
        if (!response.ok) throw new Error('Add to cart failed');
        window.location.assign(cartUrl('checkout'));
      } catch (error) {
        console.error(error);
        buyButtons.forEach((node, index) => {
          node.disabled = false;
          node.dataset.busy = 'false';
          node.textContent = index === buyButtons.indexOf(trigger) ? 'Try again' : labels[index];
        });
        window.setTimeout(() => {
          buyButtons.forEach((node, index) => {
            node.textContent = labels[index];
          });
        }, 1400);
      }
    }

    buyButtons.forEach((node) => {
      if (node.dataset.bound === 'true') return;
      node.dataset.bound = 'true';
      node.addEventListener('click', () => checkout(node));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
